var ProductQueryHelper = /** @class */ (function () {
    function ProductQueryHelper() {
    }
    ProductQueryHelper.isArrayParameter = function (parameterName) {
        switch (parameterName) {
            case 'DEPARTURE_AIRPORT_CODES':
                return true;
                break;
            case 'EXTRAS':
                return true;
                break;
            case 'FLIGHT_AIRLINE_CODES':
                return true;
                break;
            case 'FLIGHT_ARRIVAL_AIRPORT_CODES':
                return true;
                break;
            case 'FLIGHT_DEPARTURE_AIRPORT_CODES':
                return true;
                break;
            case 'FLIGHT_DEPARTURE_AIRPORT_GROUPS':
                return true;
                break;
            case 'HOTEL_ATTRIBUTES':
                return true;
                break;
            case 'HOTEL_BOARD_CODES':
                return true;
                break;
            case 'HOTEL_BOARD_GROUPS':
                return true;
                break;
            case 'HOTEL_CODES':
                return true;
                break;
            case 'HOTEL_GLOBAL_TYPES':
                return true;
                break;
            case 'HOTEL_LOCATION_CITY_CODES':
                return true;
                break;
            case 'HOTEL_LOCATION_COUNTRY_CODES':
                return true;
                break;
            case 'HOTEL_LOCATION_REGION_CODES':
                return true;
                break;
            case 'HOTEL_PRODUCT_CODES':
                return true;
                break;
            case 'HOTEL_PROVIDERS':
                return true;
                break;
            case 'HOTEL_QUALIFIERS':
                return true;
                break;
            case 'HOTEL_ROOM_ATTRIBUTES':
                return true;
                break;
            case 'HOTEL_ROOM_BOOKING_CODES':
                return true;
                break;
            case 'HOTEL_ROOM_CODES':
                return true;
                break;
            case 'HOTEL_ROOM_GROUPS':
                return true;
                break;
            case 'HOTEL_ROOM_VIEW_CODES':
                return true;
                break;
            case 'OPTIONS':
                return true;
                break;
            case 'PRODUCT_GROUPS':
                return true;
                break;
            case 'TOUR_OPERATOR_CODES':
                return true;
                break;
            case 'TRAVELLERS_CHILDREN_AGE':
                return true;
                break;
            case 'TRAVELLERS_CHILDREN_DATE_OF_BIRTH':
                return true;
                break;
            case 'TRAVEL_PERIOD_DEPARTURE_DAYS':
                return true;
                break;
            case 'TRAVEL_PERIOD_RETURN_DAYS':
                return true;
                break;
            case 'TRIP_TYPES':
                return true;
                break;
            default:
                return false;
        }
        return false;
    };
    return ProductQueryHelper;
}());
export { ProductQueryHelper };
export default ProductQueryHelper;
